import {
  FiClock,
  FiCalendar,
  FiDollarSign,
  FiMapPin,
  FiHome,
} from "react-icons/fi";
import LoginPrompt from "./LoginPrompt";
import FullButton from "../Buttons/FullButton";
import {
  Body,
  HeaderInfo,
  Section,
  StatusMessage,
} from "../../style/view.styles";
import {
  DeadlineIndicator,
  formatDate,
  getDaysRemaining,
  IconContainer,
  isDeadlineApproaching,
  MetadataContainer,
  MetadataContent,
  MetadataItem,
  MetadataLabel,
  MetadataValue,
  OrganizationContainer,
} from "../../style/opportunity.details.style";

const InternshipDetailsBody = ({
  internship,
  isLoggedIn,
  user,
  setIsApplyModalOpen,
  setIsCancelModalOpen,
  isApplyModalOpen,
  isCancelModalOpen,
  isApplicationSubmitted,
}) => {
  const deadlineApproaching = isDeadlineApproaching(internship.start_date);
  const daysRemaining = getDaysRemaining(internship.start_date);

  return (
    <Body>
      <HeaderInfo>
        <h1 className="font40 darkGreenColor extraBold">
          {internship.position}
        </h1>
        <OrganizationContainer>
          <IconContainer>
            <FiHome />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Organization</MetadataLabel>
            <MetadataValue>{internship.organization}</MetadataValue>
          </MetadataContent>
        </OrganizationContainer>
      </HeaderInfo>

      <MetadataContainer>
        <MetadataItem>
          <IconContainer>
            <FiMapPin />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Work Mode</MetadataLabel>
            <MetadataValue>{internship.work_mode}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiDollarSign />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Compensation</MetadataLabel>
            <MetadataValue>
              {internship.compensation_type || "Not specified"}
            </MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiCalendar />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Start Date</MetadataLabel>
            <MetadataValue>{formatDate(internship.start_date)}</MetadataValue>
            <DeadlineIndicator isApproaching={deadlineApproaching}>
              <FiClock />{" "}
              {daysRemaining > 0 ? `${daysRemaining} days remaining` : "Closed"}
            </DeadlineIndicator>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiClock />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>End Date</MetadataLabel>
            <MetadataValue>{formatDate(internship.end_date)}</MetadataValue>
          </MetadataContent>
        </MetadataItem>
      </MetadataContainer>

      <Section>
        <h3 className="font24 extraBold">Description</h3>
        <p className="font18" style={{ padding: "30px 0" }}>
          {internship.description}
        </p>
      </Section>

      <Section>
        {!isLoggedIn && (
          <LoginPrompt
            message="Please log in to access the application form."
            buttonText="Go To Login"
          />
        )}
        {isLoggedIn && user.role === "talent" && !isApplicationSubmitted && (
          <FullButton
            action={() => {
              setIsApplyModalOpen(!isApplyModalOpen);
            }}
            title={"Apply Here"}
          />
        )}
        {isApplicationSubmitted && (
          <StatusMessage type={"success"}>
            Application sent successfully
          </StatusMessage>
        )}
        {isLoggedIn && user.role === "organization" && (
          <FullButton
            action={() => {
              setIsCancelModalOpen(!isCancelModalOpen);
            }}
            title={"Close"}
          />
        )}
      </Section>
    </Body>
  );
};

export default InternshipDetailsBody;
